// Phase 7 — Track B T-B3. Checkbox primitive (Radix-based, token-bound).
//
// Built on `@radix-ui/react-checkbox` — sibling of the Phase 6 Radix
// catalogue. Native `<input type="checkbox">` was ruled out for the same
// reason as Select: token-bound chrome that survives forced-colors and
// dark mode portably needs Radix's data-attributes. Indeterminate state
// is supported by Radix and surfaces via the `checked="indeterminate"`
// prop pattern.

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '../../lib/cn.js';

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border border-border-default bg-surface-raised focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-default focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-accent-default data-[state=checked]:text-text-on-accent data-[state=checked]:border-accent-default',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className="flex items-center justify-center text-current"
    >
      {props.checked === 'indeterminate' ? (
        <Minus className="h-3 w-3" strokeWidth={2} aria-hidden="true" />
      ) : (
        <Check className="h-3 w-3" strokeWidth={2} aria-hidden="true" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
